import {
  Component, ChangeDetectionStrategy, OnInit, Input, OnChanges, SimpleChanges, ElementRef, EventEmitter,
  Output, DoCheck, AfterViewChecked
} from '@angular/core';
import { ViewChild, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { startOfDay, endOfDay, subDays, addDays, startOfMonth, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { CalendarEvent, DAYS_OF_WEEK, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView, CalendarMonthViewDay, } from 'angular-calendar';
import { LocalStorageService } from 'src/app/shared/services/localStorage.service';
import { GlobalvaribleService } from 'src/app/services/globalvarible.service';
import * as moment from 'moment';
import * as momenttz from 'moment-timezone';
import { DvmpService } from '../../shared/services/dvmp.service';
import {

  WeekDay,
  MonthView,
  MonthViewDay,
  ViewPeriod
} from 'calendar-utils';

const colors: any = {
  red: {
    primary: '#ff0',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  },
  green: {
    primary: '#009999',
    secondary: '#FDF1BA'
  }
};

/**
 * Restriction are handled from the below constant
 * Create new constant key with drug first 4 character in lower case
 * Ex: Darzelax = darz
 *
 */
const restriction: any = {
  darz: {
    priortoCurrentDateValidation: true,
    priortoCurrentDateMsgDisplay: false,
    priortoCurrentDateMsg: 'prior to Current Date Msg',
    priortoNextEventValidation: true,
    priortoNextEventMsgDislay: false,
    priortoNextEventMsg: 'prior to Next Event Msg',
    priortoNextEventWarning: true,
    priortoNextEventWarningDays: 7,
    priortoNextEventWarningMsg: 'La nueva pauta de Darzalex no cumple según lo establecido en Ficha Técnica'
  },
  velc: {
    priortoCurrentDateValidation: true,
    priortoCurrentDateMsgDisplay: false,
    priortoCurrentDateMsg: 'prior to Current Date Msg',
    priortoNextEventValidation: true,
    priortoNextEventMsgDislay: false,
    priortoNextEventMsg: 'prior to Next Event Msg',
    priortoNextEventWarning: true,
    priortoNextEventWarningDays: 3,
    priortoNextEventWarningMsg: 'La nueva pauta de Velcade no cumple según lo establecido en Ficha Técnica'
  }
};

@Component({
  selector: 'app-displaycalendar',
  templateUrl: './displaycalendar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./displaycalendar.component.css']
})
export class DisplaycalendarComponent implements OnInit, OnChanges {

  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  weekendDays: number[] = [DAYS_OF_WEEK.SATURDAY, DAYS_OF_WEEK.SUNDAY];
  locale = 'es';
  Today = 'today';
  cycledate: any;
  compdate: any;
  daydisplay: any;
  dateformat: any;
  applychangesDate: FormGroup;
  _localDefValues: any = [];
  @Input() drugDosageValues: any;
  @Input() printMonth: Date = new Date();
  @Input() calevents: any = {};
  @Input() index: any = {};
  currentindex: any;
  // @ViewChild('modalContent')
  // @ViewChild('content') nameInputRef: ElementRef;
  modalContent: TemplateRef<any>;
  month_display: boolean;
  toggle = true;
  config: any;
  widthExp = colors.red['primary'];
  selecteddrugname: String;
  selecteddrugcolor: String;
  @ViewChild('warningContentModal', { static: true }) warningContentModal: TemplateRef<any>;
  warningMessage = '';
  /*editevent varible start here*/
  eventstartdate: Date;
  eventenddate: Date;
  selectEvent: any;
  selectEvents: any = [];
  editeventIndex: any = [];
  editDatediff: any;
  holidayEvents = [];
  editDate: Date;
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];
  selectfetchevent: any;
  selectedby: boolean;
  diffDays: any;
  @Output() changeEvt = new EventEmitter<any>();

  externalEvents: CalendarEvent[] = [];

  /* drag and drop start here*/
  dragStartdate: Date;
  dragEndtdate: Date;
  /* drag and drop end here*/

  cycleslection: boolean;
  actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        // this.handleEvent('Edited', event);
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        // this.events = this.events.filter(iEvent => iEvent !== event);
        // this.handleEvent('Deleted', event);
      }
    }
  ];

  refresh: Subject<any> = new Subject();
  activeDayIsOpen = false;
  filteredEvents = false;
  holiday: any;
  holidayArr = [];
  constructor(public formbuilder: FormBuilder, public _localstorage: LocalStorageService, private modal: NgbModal,
    public _globalvarible: GlobalvaribleService, public _dvmp: DvmpService) {
  }

  ngOnInit() {
    console.log('display calendar file build');
    this.viewDate = new Date(this.printMonth);
    this.events = this.calevents;
    this.currentindex = this.index;
    this.month_display = this.isEventsExists();
    this.events = this.events.map(item => {
      const newdata = { ...item };
      // newdata.title=="dexametasona"
      if (newdata.title === 'dexametasona' && newdata['cycle'] === 1) {
        newdata['color'] = colors.green.primary;
      }
      return newdata;
    });

    localStorage.setItem('flag', 'true');


  }

  getEndDate(days): Date {
    return new Date(new Date(days).getTime() + (this.events.length * 24 * 60 * 60 * 1000));
  }

  ngOnChanges(changes: SimpleChanges) {
    this.events = this.calevents;

    const drugValue = this.drugDosageValues;
    if (drugValue.treatment === 'DVmp') {
      if (localStorage.getItem('drugZero') === 'true') {
        this._globalvarible.setMyGV('');
        this.filteredEvents = true;
      }
      if (drugValue.melf !== undefined && drugValue.melf === 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'Melfalán';
        });
      }

      if (drugValue.pred !== undefined && drugValue.pred === 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'Prednisona';
        });
      }

      if (drugValue.pred === 0 && drugValue.melf === 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'Prednisona' && item.title !== 'Melfalán';
        });
      }
    }
    if (drugValue.treatment === 'DVd') {
      if (localStorage.getItem('drugZero') === 'true') {
        this._globalvarible.setMyGV('');
        this.filteredEvents = true;
      }
      if (drugValue.dexa20 === 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'dexametasona';
        });
      }
    }

    if (drugValue.treatment === 'DRd') {

      if (localStorage.getItem('drugZero') === 'true') {
        this._globalvarible.setMyGV('');
        this.filteredEvents = true;
      }

      if (drugValue.dexa40 === 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'dexametasona';
        });
      }
      if (drugValue.lena === 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'lenalidomida';
        });
      }

      if (parseInt(localStorage.getItem('dexa40'), 10) === 0 && parseInt(localStorage.getItem('lena'), 10) === 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'lenalidomida' && item.title !== 'dexametasona';
        });

      }
      if (parseInt(localStorage.getItem('dexa40'), 10) > 0 && parseInt(localStorage.getItem('lena'), 10) === 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'lenalidomida';
        });

      }
      if (parseInt(localStorage.getItem('dexa40'), 10) === 0 && parseInt(localStorage.getItem('lena'), 10) > 0) {
        this.events = this.events.filter((item) => {
          return item.title !== 'dexametasona';
        });

      }

    }
    if (drugValue.treatment === 'D') {
      this.events = this.calevents;
    }
  }

  beforeMonthViewRender({ body, period, header }: { body: CalendarMonthViewDay[], period: MonthViewDay, header: WeekDay[] }): void {
    const cycle = 0;
    const l = 0;

    body.forEach(day => {
      const k = 0;
      const cicles = [];
      if (day.events.length) {
        let currrentcycle = this._globalvarible.getMyGV();
        let max_of_array;
        //  day.events.filter((item)=>{
        //    if(item["eventStart"]== true){

        //        day.badgeTotal = item["cycle"];

        //      }else {
        //       day.badgeTotal = 0;

        //      }
        // console.log("items", item);


        // });

        for (let i = 0; i < day.events.length; i++) {
          cicles.push(day.events[i]['cycle']);
        }
        max_of_array = Math.max.apply(Math, cicles);
        if (max_of_array >= 12) {
          max_of_array = max_of_array + ' ';
        }

        if (max_of_array === 0) {
          day.badgeTotal = 0;
        } else if ((currrentcycle.indexOf(max_of_array) === -1) && (day.inMonth)) {
          currrentcycle = currrentcycle + max_of_array;
          this._globalvarible.setMyGV(currrentcycle);
          day.badgeTotal = max_of_array;
          day.cssClass = 'Ciclo ' + max_of_array;
          const x = localStorage.getItem('flag');
          if (x === 'false') {
            day.badgeTotal = 0;
            this.cycledate = day.cssClass;
            this.compdate = JSON.parse(localStorage.getItem('cycleda'));
            this.daydisplay = new Date(this.compdate);
          }
        } else {
          day.badgeTotal = undefined;
        }
      }

    });
  }


  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    this._globalvarible.setMyGV(' ');

    if (isSameMonth(date, this.viewDate)) {
      this.dragStartdate = date;
      this.viewDate = date;
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
    }
  }

  isEventsExists(): boolean {
    let _local_events = this.events;
    const view_start_date = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), 1).getTime();
    const view_end_date = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 0).getTime();
    this.eventenddate = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 0);
    _local_events = _local_events.filter((res) => {
      const event_start_date = res['start'].getTime();
      if (event_start_date >= view_start_date && event_start_date <= view_end_date) {

        return res;
      }
    });
    if (_local_events.length) {


      return true;
    } else {
      return false;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    // this._globalvarible.setMyGV(" ");
    this.dragStartdate = event.start;
    this.dragEndtdate = newStart;
    event.start = newStart;
    event.end = newEnd;
    localStorage.setItem('flag', 'false');
    localStorage.setItem('cycleda', JSON.stringify(event.id));
    this.handleEvent(event);
    // this.getsomeDate(this.dragStartdate,this.dragEndtdate,event);



    this.refresh.next();
  }

  handleEvent(event: CalendarEvent): void {

    // this.modalData = { event, action };
    const eventCode = this.getEventCode(event);
    const treatmentStartDate = JSON.parse(this._localstorage.getItem('patientdetails'));
    const currentDate = new Date(treatmentStartDate.Fechaactual);
    const oneDay = 86400000;
    this._globalvarible.setMyGV(' ');
    const forwardDrag = this.isDraggedForward(this.dragStartdate, this.dragEndtdate);
    const weekendDays = new Date(this.dragEndtdate).getDay();
    const nextSameEvent = this.getNextSameEvent(event, this.dragStartdate, forwardDrag);
    const beforeSameEvent = this.getBeforeSameEvent(event, this.dragStartdate, forwardDrag, eventCode);

    if (restriction[eventCode] && restriction[eventCode] !== undefined) {

      /**
       * Prior to current date validation
       */
      if (restriction[eventCode].priortoCurrentDateValidation === true) {
        console.log(moment(this.dragEndtdate).diff(moment(currentDate), 'days') < 0);
        // if(moment(this.dragEndtdate).diff(moment(currentDate), 'days') < 0){
        if (this.dragEndtdate.getTime() - currentDate.getTime() < 0) {
          event.start = this.dragStartdate;
          if (restriction[eventCode].priortoCurrentDateMsgDisplay === true) {
            this.warningMessage = restriction[eventCode].priortoCurrentDateMsg;
            this.openModal();
          }
        }
      }
      /**
       * prior to next event validation
       */
      if (restriction[eventCode].priortoNextEventValidation === true) {
        if (this.dragEndtdate > nextSameEvent.start) {
          event.start = this.dragStartdate;
          if (restriction[eventCode].priortoNextEventMsgDislay === true) {
            this.warningMessage = restriction[eventCode].priortoNextEventMsg;
            this.openModal();
          }
        }
        /**
        * Display forward and backward to next or before event restrictions
        */
        if (restriction[eventCode].priortoNextEventWarning === true) {
          if (moment(nextSameEvent.start).diff(moment(this.dragEndtdate), 'days') >= restriction[eventCode].priortoNextEventWarningDays
            && forwardDrag === true && (weekendDays > 0 && weekendDays < 6)) {
            console.log('event.start', event.id);
            const diff = momenttz(this.dragEndtdate).diff(momenttz(event.id), 'days');
            const n = this.events.map((item) => {
              // return item['start']+diff;
            });
            // this._dvmp.updatedEvents.next({prev:event.id, curr: this.dragEndtdate, eventStart:event.start});
            // this._dvmp.updatedEvents.next(n);
            console.log('dragend-date', this.dragEndtdate);
            event.start = this.dragEndtdate;
            /**block of drugs */


            /** */
          } else if (restriction[eventCode].priortoNextEventWarningDays <= moment(this.dragEndtdate).diff(moment(beforeSameEvent.start), 'days')
            && forwardDrag === false && (weekendDays > 0 && weekendDays < 6)) {
            event.start = this.dragEndtdate;
          } else {
            event.start = this.dragStartdate;
          }
        }
      }
    }


  }

  getsomeDate(sstart, eend, drageve) {
    console.log('start and end', sstart + '' + eend + '===', drageve);
    this.events = this.events.filter((item) => {
      if (item['cycledate'] === drageve['cycledate']) {
        return item['start'] = drageve['start'];
        // return momenttz(item['start']).add(2,'d');
      }
    });
  }

  getNextSameEvent(sameEvent, startDate, forwardDrag) {
    const nextEvents = this.events.filter(e => {
      if (e.title !== '' && e.title === sameEvent.title) {
        if (moment(e.start).diff(moment(startDate), 'days') > 0) {
          return true;
        }
      }
    });

    return (forwardDrag) ? nextEvents[1] : nextEvents[0];
  }

  getBeforeSameEvent(sameEvent, startDate, forwardDrag, eventCode) {
    let beforeSameEvent;
    if (eventCode === 'darz') {
      beforeSameEvent = this.events.filter((e) => {
        return (e['title'] === 'Darzalex ®' && startDate > e['start']);
      });
    }
    if (eventCode === 'velc') {
      beforeSameEvent = this.events.filter((e) => {
        return (e['title'] === 'Velcade ®' && startDate > e['start']);
      });
    }
    return (forwardDrag) ? this.getNextSameEvent(sameEvent, startDate, forwardDrag) : beforeSameEvent[beforeSameEvent.length - 2];
  }

  isDraggedForward(start, end) {
    if (moment(start).diff(moment(end), 'days') > 0) {
      return false;
    } else {
      return true;
    }
  }

  getEventCode(event) {
    return event.title.slice(0, 4).toLowerCase();
  }

  openModal() {
    this.modal.open(this.warningContentModal, { centered: true, backdrop: 'static', keyboard: false });
  }
  open(content) {
    this.modal.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    });
  }
  addEvent(): void {
    this.events.push({
      title: 'New event',
      start: startOfDay(new Date()),
      end: endOfDay(new Date()),
      color: colors.red,
      draggable: true,
      allDay: true,
      resizable: {
        beforeStart: true,
        afterEnd: true
      }
    });
    this.refresh.next();
  }

  editEventAdminstrator() {
    const editEvent = document.getElementById('editEventChoseby');
    editEvent.style.display = 'block';
  }

  editevent(eventEdit) {
    this.selectEvent = eventEdit;
    this._globalvarible.setselectedComponnet(this.selectEvent);
    this.changeEvt.emit(this.selectEvent);
    this.eventstartdate = this.selectEvent.start;
    this.selecteddrugname = this.selectEvent.title;
    this.selecteddrugcolor = this.selectEvent.color;
    const editEvent = document.getElementById('editEvent');
    editEvent.style.display = 'block';
  }
}
